import localstorage from './localstorage'

export default {
  localstorage
}
